import { render, staticRenderFns } from "./GaIcon.vue?vue&type=template&id=d6538484&"
import script from "./GaIcon.vue?vue&type=script&lang=ts&"
export * from "./GaIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports